const menuData = [
  {
    id: 1,
    title: "Home",
    path: "/",
    type: "page",
  },
  {
    id: 2,
    title: "About GDSC RCOEM",
    path: "/#get-to-know-us",
  },
  {
    id: 6,
    title: "FAQ's",
    path: "/#faq",
  },
  {
    id: 7,
    title: "Team",
    path: "/team",
    type: "page",
  },
];

export default menuData;
